import useIsLandScapeMachine from "./useIsLandScapeMachine";

/**
 *
 * @description 此為長版機台會用到的設置
 * @returns {Object} 包含長版機台的高度、sticky top配置和padding top配置
 * @property {string} longMachineVideoHeight - 長版機台視頻高度
 * @property {Object} longMachineStickyTopConfig - 長版機台sticky top配置
 * @property {Object} longMachinePaddingTop - 長版機台padding top配置
 */
const useLongMachineSetting = () => {
  const isMachineLandscape = useIsLandScapeMachine();

  const longMachineVideoHeight = "37.5dvh";

  const longMachineStickyTopConfig = {
    base: "50px",
    md: isMachineLandscape ? `calc(${longMachineVideoHeight} + 90px)` : "0",
  };

  const longMachinePaddingTop = {
    md: isMachineLandscape ? longMachineVideoHeight : "0px",
  };

  return {
    longMachineVideoHeight,
    longMachineStickyTopConfig,
    longMachinePaddingTop,
  };
};

export default useLongMachineSetting;
